import { object } from 'prop-types'
import { useNavigate } from 'react-router'
import { ROLE_PUBLIC } from '@router/Routes'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import Div from '@ui/layout/Div'
import Buttons from '@ui/elements/Buttons'
import useHtmlRenderer from '@hook/useHtmlRenderer'
import { useEffect } from 'react'

const PrivacyPolicyPage = () => {
  const { privacyPage } = useSelector(state => state.main)
  const { title, description } = privacyPage || {}
  const renderHtml = useHtmlRenderer()
  const [t] = useTranslation('common')
  const navigate = useNavigate()

  useEffect(() => {
    if (null === privacyPage || 'undefined' === typeof privacyPage) {
      navigate(ROLE_PUBLIC['home'])
    }
  }, [privacyPage])

  return (
    <Div cssClass='privacy-page'>
      <h2 className='scene-title'>{title}</h2>
      <Div cssClass='cms-text'>
        {renderHtml(description)}
      </Div>

      <Div cssClass='actions'>
        <Buttons buttons={[
          { cssClass: 'is-success confirmation-back-home is-rounded', callback: () => navigate(ROLE_PUBLIC['home']), text: t('actions.go_home') },
        ]} />
      </Div>
    </Div>
  )
}

PrivacyPolicyPage.propTypes = {
  page: object
}

export default PrivacyPolicyPage